import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { LocationCheckLogSearch } from './LocationCheckLogSearch';
import { LocationCheckLogDisplay } from './LocationCheckLogDisplay';

/**
 * Location Check Log Routes
 *
 * Routing for location check log viewing pages
 * Read-only - no create/update/delete (logs are created by system)
 */
export const LocationCheckLogRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/display/:key" element={<LocationCheckLogDisplay />} />
    <Route path="/search" element={<LocationCheckLogSearch />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
